import React, { createContext, useReducer } from "react"
import PropTypes from "prop-types"
import {
  initialMarginsDiscountsState,
  marginsDiscountsReducer,
} from "./MarginsDiscountsReducer"

export const MarginsDiscountsContext = createContext()

export const MarginsDiscountsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    marginsDiscountsReducer,
    initialMarginsDiscountsState,
  )

  return (
    <MarginsDiscountsContext.Provider value={{ state, dispatch }}>
      {children}
    </MarginsDiscountsContext.Provider>
  )
}

MarginsDiscountsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
